<template>
  <hm-content>
    <div class="table">
      <el-table
        stripe
        :data="vipCardTypeList.records"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="typeName"
          label="会员卡类型"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="typeAppellation"
          label="身份称呼"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverGuider"
          label="身份背景图"
        >
          <template slot-scope="scope">
            <img
              style="width:100%;"
              v-if="scope.row.typeBackgroundImg"
              :src="scope.row.typeBackgroundImg"
              alt="身份背景"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="profitRemark"
          header-align="center"
          align="center"
          label="会员权益说明"
        >
          <template slot-scope="scope">
            <div
              v-html="scope.row.profitRemark"
              v-if="scope.row.profitRemark"
              class="editor"
            ></div>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="状态"
          prop="actStatus"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.enabledState == 'yes'" class="success"
              >启用</span
            >
            <span v-if="scope.row.enabledState == 'no'" class="danger"
              >停用</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="是否付费升级"
          prop="actStatus"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isPaidCard == 'yes'" class="success">是</span>
            <span v-if="scope.row.isPaidCard == 'no'" class="danger">否</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="是否绑定"
          prop="actStatus"
        >
          <template slot-scope="scope">
            <el-switch
              @change="isAllowSynchroChange(scope.row)"
              v-model="scope.row.isAllowSynchro"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              active-value="yes"
              inactive-value="no"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" content="编辑" placement="top">
              <div class="pointer mr10" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="vipCardTypeList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="编辑"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="会员卡类型：" prop="typeName">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            v-model.trim="ruleForm.typeName"
            disabled
            placeholder="请输入会员卡类型"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份称谓：" prop="typeAppellation">
          <el-input
            style="width:240px"
            size="small"
            clearable
            class="mr10 ipt"
            v-model.trim="ruleForm.typeAppellation"
            placeholder="显示在个人中心及会员卡手机端页面"
          ></el-input>
        </el-form-item>
        <el-form-item label="主图：" prop="mainImgUrl">
          <my-upload
            field="file"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="show"
            noCircle
            noSquare
            :width="750"
            :height="360"
            :headers="{ 'X-Access-Token': $token }"
            :params="{ fileDir: 'mall' }"
            :url="$uploadUrl"
            img-format="png"
          ></my-upload>
          <el-button
            type="primary"
            size="small"
            v-show="!listHeaderImgUrl"
            @click="toggleShow"
            >上传</el-button
          >
          <span class="form-tip">图片尺寸建议750x360（最多上传一张）</span>
          <div class="priview" v-if="listHeaderImgUrl">
            <img :src="listHeaderImgUrl" alt="主图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="会员描述：" prop="profitRemark">
          <hm-rich-editor
            v-model="ruleForm.profitRemark"
            :html="ruleForm.profitRemark"
          />
        </el-form-item>
      </el-form>
      <span class="flex flex-center" slot="footer">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="dialogVisible = false">返回</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";

export default {
  components: {
    myUpload,
    HmRichEditor
  },
  data() {
    return {
      cardTypeId: "",
      show: false,
      dialogVisible: false,
      pageSize: 10,
      currentPage: 1,
      appellative: "",
      ruleForm: {
        typeName: "",
        typeAppellation: "",
        profitRemark: ""
      },
      storeId: "",
      listHeaderImgUrl: "",
      rules: {
        appellative: {
          max: 10,
          message: "身份称谓不得超过10个字",
          trriger: "blur"
        },
        typeAppellation: [
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" }
        ]
      }
    };
  },
  computed: mapGetters(["vipCardTypeList"]),
  watch: {
    "goodsCategoryList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          this.queryList();
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    isAllowSynchroChange(row) {
      this.$store.dispatch("editVipCardTypeMgt", row).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogVisible = false;
          this.queryList();
        }
      });
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryVipCardTypeList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    edit(row) {
      this.dialogVisible = true;
      this.cardTypeId = row.cardTypeId;
      this.$store
        .dispatch("detailsVipCardType", {
          cardTypeId: row.cardTypeId
        })
        .then(res => {
          if (res.code == 0) {
            const result = res.result || {};

            this.listHeaderImgUrl = result.typeBackgroundImg;
            for (let key in result) {
              if (this.ruleForm.hasOwnProperty(key)) {
                this.ruleForm[key] = result[key];
              }
            }
          }
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params = Object.assign(params, {
            typeBackgroundImg: this.listHeaderImgUrl,
            cardTypeId: this.cardTypeId
          });

          this.$store.dispatch("editVipCardTypeMgt", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.dialogVisible = false;
              this.queryList();
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 360px;
  height: 175px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  .editor {
    img {
      width: 100px;
      height: 100px;
    }
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
